<script setup lang="ts">
  import { type Benchmark, BenchmarkTone } from '~/generated/api-clients-generated'

  const props = defineProps<{
    benchmark: Benchmark
    wide?: boolean
  }>()

  const segment = computed(() => (props.wide ? 'flex-1' : ''))
  const segmentWidth = computed(() => (props.wide ? 'w-full' : 'w-[33px]'))

  const segmentMap = computed(() => ({
    standout: 1,
    context: 2,
    prompt: 2,
    gap: 3
  }))

  const filledSegments = computed(() => segmentMap.value[props.benchmark.tone!])
</script>

<template>
  <div :class="['flex items-center gap-x-[2px]', { 'w-full max-w-xs': wide }]">
    <div :class="['h-[10px] rounded-l-full bg-success', segment, segmentWidth]"></div>
    <div :class="['relative', segment]">
      <div :class="['absolute h-[10px] bg-border-dark', segmentWidth]"></div>
      <div
        :class="[
          { 'origin-left scale-x-50': filledSegments === 2 },
          { 'scale-x-100': filledSegments === 3 },
          'h-[10px]',
          segmentWidth,
          { '!bg-warning': filledSegments > 1 }
        ]"
      ></div>
    </div>
    <div :class="['relative', segment]">
      <div :class="['absolute h-[10px] rounded-r-full bg-border-dark', segmentWidth]"></div>
      <div
        :class="[
          'origin-left scale-x-50',
          'h-[10px]',
          segmentWidth,
          { '!bg-danger': filledSegments > 2 }
        ]"
      ></div>
    </div>
  </div>
</template>

<style scoped></style>
